import React from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router';

// import Raven from 'raven-js';
import * as Sentry from '@sentry/browser';

import oopsImg from 'assets/images/oops.png';

import './style.scss';

class ErrorBoundary extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    children: PropTypes.any.isRequired,
    platform: PropTypes.string,
  };

  static defaultProps = {
    platform: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };

    this.handleGoHome = this.handleGoHome.bind(this);
  }

  componentDidCatch(err, extra) {
    this.setState({ hasError: true });
    Sentry.captureException(err, { extra });
  }

  /* eslint-disable */
  handleGoHome() {
    const { history, platform } = this.props;
    if (platform) {
      return window.ci.web.closePage();
    }
    history.replace('/');
  }
  /* eslint-enable */

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div styleName="oops">
          <img src={oopsImg} alt="앗! 문제가 발생했습니다." />
          <p>앗! 문제가 발생했습니다.</p>
          <button
            onClick={this.handleGoHome}
            className="full-radius-btn full-radius-btn--fill"
          >
            홈으로 돌아가기
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/app/components/common/ErrorBoundary/index.jsx